import { useState,useEffect } from "react";
import { Box, TextField, Button, MenuItem, Typography, Grid } from "@mui/material";
import DirectionsBikeIcon from "@mui/icons-material/DirectionsBike";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BadgeIcon from "@mui/icons-material/Badge";

import CarRentalSteps from "../Components/FillerComponents/taxione";
import DiscountInfo from "../Components/FillerComponents/taxitwo";
   

const BikeBookingSection = ({ backgroundImage }) => {

    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top when component mounts
      }, []);
    
  const [formData, setFormData] = useState({
    name: "",
    bikeType: "",
    pickupLocation: "",
    phone: "",
  });

  

  const travelOwnerNumber = "6230206562"; // Replace with actual WhatsApp number

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const { name, bikeType, pickupLocation, phone } = formData;

    if (!name || !bikeType || !pickupLocation || !phone) {
      alert("Please fill all fields");
      return;
    }

    const message = `Bike Booking Request:
    - Name: ${name}
    - Bike: ${bikeType}
    - Pickup Location: ${pickupLocation}
    - Phone: ${phone}`;

    const whatsappURL = `https://wa.me/${travelOwnerNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <Box>
      {/* Background Image + Form Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: "450px",
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px",
          "&:before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay effect
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            backgroundColor: "rgba(255, 255, 255, 0.84)",
            padding: "30px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            width: "100%",
            maxWidth: "650px",
            textAlign: "center",
            zIndex: 2,
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Book Your Bike Ride
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              select
              label="Select Bike"
              name="bikeType"
              variant="outlined"
              value={formData.bikeType}
              onChange={handleChange}
            >
              <MenuItem value="Royal Enfield Himalayan">Royal Enfield Himalayan</MenuItem>
              <MenuItem value="BMW G 310 GS">BMW G 310 GS</MenuItem>
              <MenuItem value="KTM 250 Adventure">KTM 250 Adventure</MenuItem>
              <MenuItem value="Hero Xpulse 200">Hero Xpulse 200</MenuItem>
              <MenuItem value="Suzuki V-Strom 650XT">Suzuki V-Strom 650XT</MenuItem>
              <MenuItem value="Kawasaki Versys 1000">Kawasaki Versys 1000</MenuItem>
            </TextField>
            <TextField
              fullWidth
              label="Pick Up Location"
              name="pickupLocation"
              variant="outlined"
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              fullWidth
              label="Your Name"
              name="name"
              variant="outlined"
              onChange={handleChange}
            />
            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              type="tel"
              variant="outlined"
              onChange={handleChange}
            />
          </Box>
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#FFC107",
              color: "#000",
              marginTop: "20px",
              fontSize: "18px",
              fontWeight: "bold",
              padding: "10px",
              borderRadius: "30px",
              "&:hover": { backgroundColor: "#FFA000" },
            }}
            onClick={handleSubmit}
          >
            BOOK NOW
          </Button>
        </Box>
      </Box>

      {/* Features Section */}
      <Box sx={{ backgroundColor: "#F8F9FA", padding: "40px 20px" }}>
        <Grid container spacing={3} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#FFC107",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "auto",
                    marginBottom: "10px",
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography variant="h6" fontWeight="bold">
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <CarRentalSteps />
      <DiscountInfo />
    </Box>
  );
};

// Feature Cards Data
const features = [
  {
    title: "24 Hours Support",
    description: "Our travel experts are available 24/7 for bike rentals in Shimla & Manali.",
    icon: <WatchLaterIcon fontSize="large" />,
  },
  {
    title: "Well Maintained Bikes",
    description: "We provide high-quality, well-maintained adventure bikes for your journey.",
    icon: <DirectionsBikeIcon fontSize="large" />,
  },
  {
    title: "Quality Assurance",
    description: "We assure a top-notch bike rental experience with excellent service.",
    icon: <CheckCircleIcon fontSize="large" />,
  },
  {
    title: "Experienced Guides",
    description: "Our team offers expert guidance on the best biking routes and safety measures.",
    icon: <BadgeIcon fontSize="large" />,
  },
];

export default BikeBookingSection;
